import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { timeout } from '@/utils/common'

interface ProximaCirurgia {
  id: string,
  hospital: string,
  paciente: string,
  procedimento: string,
  dataAgendamento: Date | string,
  nomeMedico: string,
  situacao: {
    key: string,
    display: string,
  }
}
@Module({ namespaced: true, name: 'HomeAgendamentoStore' })
export default class HomeAgendamentoStore extends VuexModule {
  private proximasCirurgiasDefault: ProximaCirurgia[] = []
  public agendamentosMesAtualTotal: number = 0
  public agendamentosMesAnteriorTotal: number = 0
  public agendamentosAnoAtualTotal: number = 0
  public agendamentosTotal: number = 0
  public proximasCirurgias: ProximaCirurgia[] = [...this.proximasCirurgiasDefault]

  @Mutation
  setAgendamentosMesAtualTotal(value: number) {
    this.agendamentosMesAtualTotal = value
  }

  @Mutation
  clearAgendamentosMesAtualTotal() {
    this.agendamentosMesAtualTotal = 0
  }

  @Mutation
  setAgendamentosMesAnteriorTotal(value: number) {
    this.agendamentosMesAnteriorTotal = value
  }

  @Mutation
  clearAgendamentosMesAnteriorTotal() {
    this.agendamentosMesAnteriorTotal = 0
  }

  @Mutation
  setAgendamentosAnoAtualTotal(value: number) {
    this.agendamentosAnoAtualTotal = value
  }

  @Mutation
  clearAgendamentosAnoAtualTotal() {
    this.agendamentosAnoAtualTotal = 0
  }

  @Mutation
  setAgendamentosTotal(value: number) {
    this.agendamentosTotal = value
  }

  @Mutation
  clearAgendamentosTotal() {
    this.agendamentosTotal = 0
  }

  @Mutation
  setProximasCirurgias(value: ProximaCirurgia[]) {
    this.proximasCirurgias = value
  }

  @Mutation
  clearProximasCirurgias() {
    this.proximasCirurgias = [...this.proximasCirurgiasDefault]
  }

  @Action
  async getAgendamentoSummaryData() {
    try {
      const request = {
        success: true,
        data: {
          agendamentosMesAtualTotal: 41,
          agendamentosMesAnteriorTotal: 29,
          agendamentosAnoAtualTotal: 321,
          agendamentosTotal: 440,
          proximasCirurgias: [
            {
              id: '19f57920-3de5-43e5-97f6-346450842dbd',
              hospital: 'HOSPITAL NOSSA SENHORA DO CARMO',
              paciente: 'João Henrique Souza Carvalho',
              procedimento: 'Adeno tonsilectomia - Revisão cirúrgica',
              dataAgendamento: '2023-03-09T13:45:00',
              nomeMedico: 'Adriano Santos Magalhães',
              situacao: {
                key: 'Autorizada',
                display: 'Autorizada',
              },
            },
            {
              id: '19f57820-3de5-43e5-97f6-346450842dbd',
              hospital: 'MATERNIDADE SANTA CRUZ',
              paciente: 'Juliana Peña Albuquerque',
              procedimento: 'Cesárea',
              dataAgendamento: '2023-05-14T07:00:00',
              nomeMedico: 'Sandra Sarcomani Toledesco',
              situacao: {
                key: 'AnalisePreAutorizacao',
                display: 'Análise pré-autorização',
              },
            },
            {
              id: '19f57720-3de5-43e5-97f6-346450842dbd',
              hospital: 'HOSPITAL NOVE DE JULHO',
              paciente: 'Péricles Meneguel de Alcântara',
              procedimento: 'Rinoseptoplastia',
              dataAgendamento: '2023-04-21T12:30:00',
              nomeMedico: 'Juscelino Tavares Azevedo',
              situacao: {
                key: 'Autorizada',
                display: 'Autorizada',
              },
            },
          ],
        },
      }

      await timeout(1000)
      this.context.commit('setAgendamentosMesAtualTotal', request.data.agendamentosMesAtualTotal || 0)
      this.context.commit('setAgendamentosMesAnteriorTotal', request.data.agendamentosMesAnteriorTotal || 0)
      this.context.commit('setAgendamentosAnoAtualTotal', request.data.agendamentosAnoAtualTotal || 0)
      this.context.commit('setAgendamentosTotal', request.data.agendamentosTotal || 0)
      this.context.commit('setProximasCirurgias', request.data.proximasCirurgias || [])

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
